import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-choices-component',
  templateUrl: './choices-component.component.html',
  styleUrls: ['./choices-component.component.scss'],
})
export class ChoicesComponentComponent {
  @Input() component: any;
  @Input() step: any;
  @Input() scenario: any;

  constructor(
    private playerSessionService: PlayerSessionService,
    public playerService: PlayerService,
    public statesService: StatesService,
    public contentService: ContentService
  ) {}
  ngOnInit(): void {}

  onFocus(choice: any) {
    this.statesService.onFocus(this.component, choice);
  }
  onBlur(choice: any) {
    this.statesService.onBlur(this.component, choice);
  }
  onMouseDown(choice: any) {
    
    this.statesService.onMouseDown(this.component, choice);
    this.component.choices.forEach((choice: any) => {
      this.statesService.clearStates(choice, ['hover', 'focus', 'active']);
    });
  }
  onMouseUp(choice: any) {
    this.statesService.onMouseUp(this.component, choice);
  }

  onMouseEnter(choice: any) {
    this.statesService.onMouseEnter(this.component, choice);
  }
  onMouseLeave(choice: any) {
    this.statesService.onMouseLeave(this.component, choice);
  }
  stringify(object: object) {
    return JSON.stringify(object);
  }
  ngOnDestroy() {
    // clear the hover, active and focus states on choices
    this.component.choices.forEach((choice: any) => {
      this.statesService.clearStates(choice, ['hover', 'focus', 'active']);
    });
  }
}
